import { useState, useEffect, useRef } from "react";

const MAILTO_LINK =
  "mailto:jimenao@lclogisticcr.com?subject=Solicitud%20de%20cotizaci%C3%B3n%20log%C3%ADstica&body=Hola%20equipo%20de%20LC%20Logistic%2C%0AMe%20gustar%C3%ADa%20recibir%20informaci%C3%B3n%20o%20una%20cotizaci%C3%B3n%20para%20un%20servicio%20log%C3%ADstico%20internacional.%0ASomos%20una%20empresa%20dedicada%20a%20%5Bbreve%20descripci%C3%B3n%20de%20la%20empresa%5D%2C%20por%20lo%20que%20estamos%20interesados%20en%20conocer%20opciones%20que%20se%20ajusten%20a%20nuestras%20necesidades%20log%C3%ADsticas.%0ATipo%20de%20carga%3A%0AOrigen%3A%0ADestino%3A%0APeso%20o%20volumen%20aproximado%3A%0AFecha%20estimada%20de%20env%C3%ADo%3A%0AQuedo%20atento(a)%20a%20su%20respuesta.%0AMuchas%20gracias.";

const MAILTO_CONTACT =
  "mailto:jimenao@lclogisticcr.com?subject=Solicitud%20de%20cotizaci%C3%B3n%20log%C3%ADstica&body=Hola%20equipo%20de%20LC%20Logistic%2C%0AMe%20gustar%C3%ADa%20recibir%20informaci%C3%B3n%20o%20una%20cotizaci%C3%B3n%20para%20un%20servicio%20log%C3%ADstico%20internacional.%0ASomos%20una%20empresa%20dedicada%20a%20%5Bbreve%20descripci%C3%B3n%20de%20la%20empresa%5D%2C%20por%20lo%20que%20estamos%20interesados%20en%20conocer%20opciones%20que%20se%20ajusten%20a%20nuestras%20necesidades%20log%C3%ADsticas.%0ATipo%20de%20carga%3A%0AOrigen%3A%0ADestino%3A%0APeso%20o%20volumen%20aproximado%3A%0AFecha%20estimada%20de%20env%C3%ADo%3A%0AQuedo%20atento(a)%20a%20su%20respuesta.%0AMuchas%20gracias.";

function useIntersection(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return { ref, visible };
}

function AnimatedSection({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  const { ref, visible } = useIntersection();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${className}`}
    >
      {children}
    </div>
  );
}

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navLinks = [
    { label: "Home", id: "home" },
    { label: "Nosotros", id: "nosotros" },
    { label: "Servicios", id: "servicios" },
    { label: "Incoterms", id: "incoterms" },
    { label: "Agentes", id: "agentes" },
  ];

  return (
    <div className="font-sans bg-white text-black min-h-screen">
      {/* NAVBAR */}
      <nav
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          scrolled ? "bg-white shadow-md" : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <img
            src="https://storage.readdy-site.link/project_files/07fa21dc-34fd-4ee8-9216-c27e466017e1/a1581e15-92ac-44b7-9377-111c4ea0c807_Diseo-sin-ttulo-16.png?v=1826ff26ffdb270506c4d1d3ba2306cc"
            alt="LC Logistic"
            className="h-24 w-auto object-contain"
          />
          {/* Desktop nav */}
          <ul className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <li key={link.id}>
                <button
                  onClick={() => scrollTo(link.id)}
                  className={`text-sm font-medium tracking-wide uppercase transition-colors hover:opacity-60 ${
                    scrolled ? "text-black" : "text-white"
                  }`}
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
          {/* Mobile hamburger */}
          <button
            className={`md:hidden text-2xl ${scrolled ? "text-black" : "text-white"}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden bg-white shadow-lg px-6 pb-6 pt-2">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                className="block w-full text-left py-3 text-sm font-medium uppercase tracking-wide text-black border-b border-gray-100 last:border-0"
              >
                {link.label}
              </button>
            ))}
          </div>
        )}
      </nav>

      {/* HERO */}
      <section
        id="home"
        className="relative min-h-screen flex items-center justify-center text-center overflow-hidden"
      >
        <img
          src="https://public.readdy.ai/ai/img_res/44eaa5818693759b563f6acc33180407.jpg"
          alt="LC Logistic Hero"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <AnimatedSection>
            <p className="text-xs uppercase tracking-widest text-gray-300 mb-4">Logística Internacional</p>
            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
              Soluciones logísticas internacionales eficientes y seguras
            </h1>
            <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl mx-auto">
              Ayudamos a empresas en sus procesos de importación mediante soluciones logísticas confiables y personalizadas.
            </p>
            <a
              href={MAILTO_LINK}
              className="inline-block bg-white text-black font-semibold text-sm uppercase tracking-widest px-10 py-4 rounded-full hover:bg-gray-100 transition-all duration-300 hover:scale-105"
            >
              Solicitar cotización
            </a>
          </AnimatedSection>
        </div>
      </section>

      {/* HIGHLIGHTS */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <AnimatedSection>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-center">
              {[
                { icon: "ri-global-line", title: "Cobertura Internacional", desc: "Presencia en los principales centros logísticos del mundo." },
                { icon: "ri-award-line", title: "Experiencia Logística", desc: "Años de trayectoria en comercio internacional." },
                { icon: "ri-settings-3-line", title: "Soluciones Integrales", desc: "Servicios completos adaptados a cada operación." },
              ].map((item) => (
                <div key={item.title} className="flex flex-col items-center">
                  <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                  <p className="text-gray-500 text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* NOSOTROS */}
      <section id="nosotros" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <AnimatedSection>
            <div className="text-center mb-16">
              <h2 className="text-5xl font-bold text-black mb-4">¿Quiénes Somos?</h2>
              <div className="w-16 h-1 bg-black mx-auto"></div>
            </div>
          </AnimatedSection>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
            <AnimatedSection>
              <p className="text-gray-600 text-lg leading-relaxed mb-6">
                LC LOGISTIC es una empresa privada costarricense dedicada a proporcionar soluciones logísticas integrales para el comercio internacional. Con más&nbsp;de 20 años&nbsp;de experiencia en el sector, se ha consolidado como un socio confiable para empresas que buscan optimizar sus operaciones de importación.
              </p>
              <div className="space-y-6">
                <div>
                  <h4 className="text-lg font-bold mb-1">Misión</h4>
                  <p className="text-gray-600 text-sm leading-relaxed">Facilitar el comercio internacional mediante servicios logísticos eficientes, seguros y personalizados.</p>
                </div>
                <div>
                  <h4 className="text-lg font-bold mb-1">Visión</h4>
                  <p className="text-gray-600 text-sm leading-relaxed">Ser reconocidos como una empresa líder en servicios logísticos en Costa Rica por su innovación, confiabilidad y compromiso con el cliente.</p>
                </div>
              </div>
            </AnimatedSection>
            <AnimatedSection>
              <div className="rounded-2xl overflow-hidden shadow-lg h-80">
                <img
                  src="https://static.readdy.ai/image/a38d5a1d1110e4d660f91689d130c3f9/ac0914ee774086b6571e03d27374dad0.jpeg"
                  alt="Equipo LC Logistic"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </AnimatedSection>
          </div>

          {/* Valores */}
          <AnimatedSection>
            <div className="bg-white rounded-2xl p-10 shadow-sm mb-16">
              <h3 className="text-2xl font-bold text-center mb-8">Nuestros Valores</h3>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-6 text-center">
                {[
                  { icon: "ri-star-line", label: "Excelencia en servicio" },
                  { icon: "ri-shield-line", label: "Integridad y transparencia" },
                  { icon: "ri-lightbulb-line", label: "Innovación constante" },
                  { icon: "ri-heart-line", label: "Compromiso con el cliente" },
                  { icon: "ri-earth-line", label: "Responsabilidad social" },
                ].map((v) => (
                  <div key={v.label} className="flex flex-col items-center">
                    <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-3">
                      <i className={`${v.icon} text-xl text-black`}></i>
                    </div>
                    <p className="text-xs text-gray-600 font-medium">{v.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </AnimatedSection>

          {/* Por qué elegirnos */}
          <AnimatedSection>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
              <div>
                <h3 className="text-2xl font-bold mb-6">¿Por qué elegirnos?</h3>
                <ul className="space-y-4">
                  {[
                    "Experiencia comprobada en logística internacional.",
                    "Red global de socios estratégicos.",
                    "Tecnología para seguimiento logístico.",
                    "Atención personalizada para cada cliente.",
                  ].map((item) => (
                    <li key={item} className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-line text-xl text-black flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-600">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              {/* Contáctenos */}
              <div className="bg-black rounded-2xl p-8 text-white flex flex-col justify-center">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-mail-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold mb-3">Contáctenos</h3>
                <p className="text-gray-300 text-sm mb-6 leading-relaxed">
                  Escriba al correo para consultas o cotizaciones de importaciones o exportaciones.
                </p>
                <a
                  href={MAILTO_CONTACT}
                  className="inline-block bg-white text-black font-semibold text-sm uppercase tracking-widest px-8 py-3 rounded-full hover:bg-gray-100 transition-all duration-300 hover:scale-105 text-center"
                >
                  Contáctenos
                </a>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* SERVICIOS */}
      <section id="servicios" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <AnimatedSection>
            <div className="text-center mb-16">
              <h2 className="text-5xl font-bold text-black mb-4">Nuestros Servicios</h2>
              <div className="w-16 h-1 bg-black mx-auto mb-6"></div>
              <p className="text-lg text-gray-500 max-w-3xl mx-auto">
                Soluciones logísticas completas para todas sus necesidades de comercio internacional
              </p>
            </div>
          </AnimatedSection>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <AnimatedSection>
              <div className="bg-gray-50 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300">
                <div className="relative h-64">
                  <img
                    src="https://static.readdy.ai/image/a38d5a1d1110e4d660f91689d130c3f9/b7573cd14f2e69efdf98174d65072702.jpeg"
                    alt="Carga Aérea"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-8">
                  <div className="w-14 h-14 bg-black rounded-full flex items-center justify-center mb-4">
                    <i className="ri-plane-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-black mb-4">Carga Aérea</h3>
                  <ul className="space-y-3">
                    {[
                      "Transporte internacional rápido",
                      "Tarifas competitivas",
                      "Embalajes seguros",
                      "Gestión de documentación",
                      "Recepción de cargas en distintas partes del mundo",
                      "Servicio Door to Door",
                      "Instalaciones seguras para su carga",
                      "Seguimiento logístico en tiempo real",
                    ].map((item) => (
                      <li key={item} className="flex items-start space-x-3">
                        <i className="ri-arrow-right-s-line text-xl text-black flex-shrink-0 mt-0.5"></i>
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </AnimatedSection>

            <AnimatedSection>
              <div className="bg-gray-50 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300">
                <div className="relative h-64">
                  <img
                    src="https://static.readdy.ai/image/a38d5a1d1110e4d660f91689d130c3f9/9d6789c382e9277d687d6c362d6e9fd1.jpeg"
                    alt="Carga Marítima"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-8">
                  <div className="w-14 h-14 bg-black rounded-full flex items-center justify-center mb-4">
                    <i className="ri-ship-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-black mb-4">Carga Marítima</h3>
                  <ul className="space-y-3">
                    {[
                      "Contenedores secos y refrigerados",
                      "Contenedores mixtos con control de temperatura",
                      "Diversas rutas marítimas",
                      "Opciones FCL (contenedor completo) y LCL (carga consolidada)",
                      "Conexión con puertos internacionales y optimización de costos",
                    ].map((item) => (
                      <li key={item} className="flex items-start space-x-3">
                        <i className="ri-arrow-right-s-line text-xl text-black flex-shrink-0 mt-0.5"></i>
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </AnimatedSection>
          </div>

          <AnimatedSection>
            <div className="bg-gray-50 rounded-2xl p-10 shadow-sm">
              <h3 className="text-3xl font-bold text-black mb-8 text-center">Servicios Adicionales</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[
                  { icon: "ri-file-list-3-line", title: "Servicios de Agencia Aduanal", desc: "Nacionalización de carga y trámites aduanales" },
                  { icon: "ri-building-line", title: "Transporte", desc: "Coordinación de transporte local de su mercancía." },
                  { icon: "ri-shield-check-line", title: "Seguro de Carga", desc: "Protección integral para sus envíos internacionales." },
                ].map((s) => (
                  <div key={s.title} className="text-center">
                    <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className={`${s.icon} text-2xl text-white`}></i>
                    </div>
                    <h4 className="text-xl font-bold text-black mb-3">{s.title}</h4>
                    <p className="text-gray-600 text-sm">{s.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* INCOTERMS */}
      <section id="incoterms" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <AnimatedSection>
            <div className="text-center mb-16">
              <h2 className="text-5xl font-bold text-black mb-4">Incoterms</h2>
              <div className="w-16 h-1 bg-black mx-auto mb-6"></div>
              <p className="text-lg text-gray-500 max-w-3xl mx-auto">
                Los Incoterms (International Commercial Terms) son reglas publicadas por la Cámara de Comercio Internacional que definen las responsabilidades entre compradores y vendedores en el comercio internacional.
              </p>
            </div>
          </AnimatedSection>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            <AnimatedSection>
              <div className="bg-white rounded-2xl p-8 shadow-sm h-full">
                <h3 className="text-xl font-bold mb-6 flex items-center space-x-3">
                  <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-global-line text-white text-lg"></i>
                  </div>
                  <span>Cualquier término&nbsp;de transporte</span>
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  {["EXW", "FCA", "CPT", "CIP", "DAP", "DPU", "DDP"].map((term) => (
                    <div key={term} className="bg-gray-50 rounded-xl px-4 py-3 flex items-center space-x-3">
                      <span className="font-bold text-black text-sm">{term}</span>
                    </div>
                  ))}
                </div>
              </div>
            </AnimatedSection>

            <AnimatedSection>
              <div className="bg-white rounded-2xl p-8 shadow-sm h-full">
                <h3 className="text-xl font-bold mb-6 flex items-center space-x-3">
                  <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-ship-line text-white text-lg"></i>
                  </div>
                  <span>Transporte marítimo o fluvial</span>
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  {["FAS", "FOB", "CFR", "CIF"].map((term) => (
                    <div key={term} className="bg-gray-50 rounded-xl px-4 py-3 flex items-center space-x-3">
                      <span className="font-bold text-black text-sm">{term}</span>
                    </div>
                  ))}
                </div>
              </div>
            </AnimatedSection>
          </div>

          <AnimatedSection>
            <div className="bg-white rounded-2xl p-10 shadow-sm">
              <h3 className="text-2xl font-bold text-center mb-8">Importancia de los Incoterms</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
                {[
                  { icon: "ri-money-dollar-circle-line", title: "Costos", desc: "Definen quién asume los gastos de transporte, seguros y trámites en cada etapa." },
                  { icon: "ri-error-warning-line", title: "Riesgos", desc: "Establecen el punto exacto donde el riesgo de pérdida o daño se transfiere al comprador." },
                  { icon: "ri-file-text-line", title: "Trámites", desc: "Determinan las responsabilidades aduaneras y documentales de cada parte." },
                ].map((item) => (
                  <div key={item.title}>
                    <div className="w-14 h-14 bg-black rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className={`${item.icon} text-2xl text-white`}></i>
                    </div>
                    <h4 className="font-bold text-lg mb-2">{item.title}</h4>
                    <p className="text-gray-500 text-sm">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* AGENTES */}
      <section id="agentes" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <AnimatedSection>
            <div className="text-center mb-16">
              <h2 className="text-5xl font-bold text-black mb-4">Nuestra Red Global</h2>
              <div className="w-16 h-1 bg-black mx-auto mb-6"></div>
              <p className="text-lg text-gray-500 max-w-3xl mx-auto">
                LC Logistic cuenta con una red de agentes y socios estratégicos en los principales centros logísticos del mundo, permitiendo ofrecer cobertura internacional y continuidad en las operaciones.
              </p>
            </div>
          </AnimatedSection>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <AnimatedSection>
              <div className="rounded-2xl overflow-hidden shadow-lg h-80">
                <img
                  src="https://static.readdy.ai/image/a38d5a1d1110e4d660f91689d130c3f9/1855a158e20b941629001306764363f4.jpeg"
                  alt="Red Global LC Logistic"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </AnimatedSection>

            <AnimatedSection>
              <h3 className="text-2xl font-bold mb-8">Ventajas de nuestra red</h3>
              <ul className="space-y-6">
                {[
                  { icon: "ri-chat-3-line", text: "Comunicación fluida en toda la cadena logística." },
                  { icon: "ri-focus-3-line", text: "Gestión integral con un solo punto de contacto." },
                  { icon: "ri-map-pin-2-line", text: "Conocimiento local de regulaciones en cada mercado." },
                  { icon: "ri-price-tag-3-line", text: "Tarifas competitivas gracias a acuerdos globales." },
                ].map((item, i) => (
                  <li key={i} className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-xl text-white`}></i>
                    </div>
                    <p className="text-gray-600 leading-relaxed pt-2">{item.text}</p>
                  </li>
                ))}
              </ul>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-black text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="flex flex-col items-center md:items-start gap-2">
              <img
                src="https://storage.readdy-site.link/project_files/07fa21dc-34fd-4ee8-9216-c27e466017e1/a1581e15-92ac-44b7-9377-111c4ea0c807_Diseo-sin-ttulo-16.png?v=1826ff26ffdb270506c4d1d3ba2306cc"
                alt="LC Logistic"
                className="h-16 w-auto object-contain"
              />
              <p className="text-gray-400 text-sm">Soluciones logísticas internacionales</p>
            </div>
            {/* Redes sociales */}
            <div className="flex items-center gap-5">
              <a
                href="https://www.facebook.com/lclogisticcr?locale=es_LA"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-gray-300 hover:text-white hover:border-white transition-all duration-300"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/lc_logistic__cr?igsh=MTF1NGliZ2I5OWxraQ=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-gray-300 hover:text-white hover:border-white transition-all duration-300"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>

            </div>
          </div>
          <div className="border-t border-white/10 mt-8 pt-6 text-center">
            <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} LC Logistic. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
